// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__c-1Xq","gameBetButton":"styles_gameBetButton__AY8tx"};